import { createFileRoute } from '@tanstack/react-router';
import { CustomerListPage } from '@/features/customers/CustomerListPage';

export const Route = createFileRoute('/_app/customers/companies')({
  component: () => <CustomerListPage kind="COMPANY" />,
});
